import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReport1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M11.111 3.79 5.588 6.98A2.202 2.202 0 0 0 4.5 8.87v6.363a2.18 2.18 0 0 0 1.085 1.89l5.523 3.189h.001a2.19 2.19 0 0 0 2.182.002l5.52-3.188.003-.002a2.199 2.199 0 0 0 1.088-1.892v-6.36a2.19 2.19 0 0 0-1.088-1.892l-1.916-1.106-3.604-2.081-.001-.001a2.192 2.192 0 0 0-2.182 0Zm2.93-1.299 2.482 1.433 3.044 1.758.005.003a3.69 3.69 0 0 1 1.83 3.186v6.363c0 1.31-.701 2.522-1.83 3.186l-.005.003-5.526 3.19a3.693 3.693 0 0 1-3.677.002l-.003-.002-5.526-3.19A3.68 3.68 0 0 1 3 15.233V8.872c0-1.31.701-2.523 1.83-3.186l.005-.003 5.526-3.19a3.692 3.692 0 0 1 3.677-.002l.003.001Zm-1.835 4.861a.75.75 0 0 1 .75.75v4.884a.75.75 0 1 1-1.5 0V8.102a.75.75 0 0 1 .75-.75Zm1 8.61a1 1 0 1 0-2 0v.092a1 1 0 0 0 2 0v-.093Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgReport1;
